export const AUTH_TOKEN = "adm_auth_token";
